<template>
  <Conversations :controller="controller" :help-text-by-type="helpTextByType" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Conversations, type ConversationsController } from '@staff/ui'
import { useMetadata } from '@/composables/useMetadata'

defineProps<{ controller: ConversationsController }>()

const { getReferenceValues } = useMetadata()
const helpTextByType = computed(() =>
  Object.fromEntries(getReferenceValues('conversationTypes').map(({ code, helpText }) => [code, helpText])),
)
</script>
